import React, { useState } from "react";
import "./css/files.css";
import { CustomerFilesData } from "./components/CustomerFilesData/CustomerFilesData";
import { UploadCustomerFiles } from "./components/UploadFiles/UploadCustomerFiles";

export const MainCustomerFile = ({ cpData }) => {
  // Used to trigger re-fetch of customer files after upload/delete
  const [refreshCustomerFiles, setRefreshCustomerFiles] = useState(false);

  return (
    <div className="main-files">
      {/* Customer files listing */}
      <CustomerFilesData
        cpData={cpData}
        refreshCustomerFiles={refreshCustomerFiles}
      />

      {/* Upload new files */}
      <UploadCustomerFiles
        cpData={cpData}
        setRefreshCustomerFiles={setRefreshCustomerFiles}
      />
    </div>
  );
};
